/**
The main entry point for OV Lookbooks.
Referenced by page.lookbook.liquid templates.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import PageHomepage from './apps/pages/homepage';
import OVApp from './utils/OVContext'; // Live Women's Lookbook ID

import { jsx as _jsx } from "react/jsx-runtime";
var defaultId = 'SG9tZXBhZ2VOb2RlOjQzNg=='; // Get homepage ID from Shopify page content

var pageElement = document.getElementById('lookbook');
var pageContentId = pageElement.getAttribute('data-homepage-id');
var homepageId = pageContentId ? pageContentId : defaultId;
ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
  children: /*#__PURE__*/_jsx(PageHomepage, {
    id: homepageId,
    pageTitle: "The Outfitting Guide",
    title: "Dressed for the outdoors.",
    subtitle: "OV Outdoors outfitting guide"
  })
}), document.getElementById('lookbook'));